var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { billingApi } from 'apis/billing';
/**
 * UseConfirmPaymentMethod is a hook that gets a Stripe setup intent and uses
 * the setupIntent to confirm a payment method in stripe.
 *
 * This is a flow for authorizing using 3ds2.
 */
export const useConfirmPaymentMethod = () => {
    const stripe = useStripe();
    const [isLoading, setIsLoading] = useState(false);
    const [createSetupIntent] = billingApi.useCreateSetupIntentMutation();
    const confirmPaymentMethod = (
    /** Payment method id */
    id) => __awaiter(void 0, void 0, void 0, function* () {
        if (!stripe)
            return;
        setIsLoading(true);
        let caughtError;
        try {
            const { data: creatSetupIntentData } = yield createSetupIntent().unwrap();
            const { setupIntent, error: confirmCardSetupError } = yield stripe.confirmCardSetup(creatSetupIntentData.client_secret, {
                payment_method: id,
            });
            setIsLoading(false);
            if (confirmCardSetupError) {
                throw confirmCardSetupError;
            }
            return setupIntent;
        }
        catch (error) {
            setIsLoading(false);
            caughtError = error;
        }
        if (caughtError) {
            throw caughtError;
        }
    });
    return [confirmPaymentMethod, { isLoading: isLoading }];
};
